<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">
    <div class="wrapper">
      <side-bar>
        <template slot="links">
          <sidebar-link v-if="isAdmin" :name="$t('sidebar.NewMeasurement')" icon="ti-plus" to="/measurement/create" />
          <sidebar-link :name="$t('sidebar.Overview')" icon="ti-list" to="/measurement/index" />
          <sidebar-link :name="$t('sidebar.Monitoring')" icon="ti-alert" to="/measurement/monitoring" />
          <sidebar-link :name="$t('sidebar.Components')" icon="ti-package" to="/component/index" />
          <sidebar-link v-if="isAdmin" :name="$t('sidebar.Customers')" icon="ti-id-badge" to="/customer/index" />
          <sidebar-link v-if="isAdmin" :name="$t('sidebar.Brands')" icon="ti-truck" to="/brand/index" />
          <sidebar-link v-if="isAdmin" :name="$t('sidebar.Users')" icon="ti-key" to="/user/index" />
          <li class="nav-item">
            <a class="nav-link" href="#" @click="logout">
              <i class="ti-power-off"></i>
              <p>{{ $t('sidebar.Logout') }}</p>
            </a>
          </li>
        </template>
        <mobile-menu>
          <li class="nav-item">
            <a class="nav-link">
              <i class="ti-user"></i>
              <p>
                {{ user.user.name }}
              </p>
            </a>
          </li>
          <li class="divider"></li>
        </mobile-menu>
      </side-bar>
      <div class="main-panel">
        <top-navbar></top-navbar>

        <dashboard-content @click.native="toggleSidebar">

        </dashboard-content>
      </div>
    </div>
  </div>
</template>
<script>
import TopNavbar from "./TopNavbar.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";

export default {
  data() {
    return {
      user: this.$store.getters.USER,
    }
  },
  components: {
    TopNavbar,
    DashboardContent,
    MobileMenu
  },
  created() {
    this.$store.dispatch('userData')
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    async logout() {
      this.$swal({
        title: this.$t('swal.logout.Title'),
        text: this.$t('swal.logout.Text'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: this.$t('swal.logout.CancelButtonText'),
        confirmButtonText: this.$t('swal.logout.ConfirmButtonText')
      }).then(async (result) => {
            if (result.value) {
              await this.$store.dispatch('destroyToken')
            }
          }
      )
    },
  },
  computed: {
    getRole() {
      return this.user.user.roles[0].name
    },
    isAdmin(){
      return (this.getRole === 'admin' || this.getRole === 'super admin') ? true : false
    }
  }
};
</script>
